<template>
  <BaseImage
    v-bind="$attrs"
    v-on="$listeners"
    :href="disableLink ? null : href"
    :src="src"
    :styleConfig="styleConfig"
  />
</template>

<script>
  import BaseImage from '@base/v2/base-image'
  import { IMAGE_FILES } from '@js/constants'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  const path = require('path');

  export default {
    name: 'UserImagePrimary',
    inheritAttrs: false,
    components: {
      BaseImage,
    },
    props: {
      disableLink: {
        type: Boolean,
        required: false,
        default: false,
      },
      size: {
        type: String,
        required: false,
        default: Layout.space.lg,
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        defaultSrc: '',
        imageFile: IMAGE_FILES.PLACEHOLDER.USER,
        styleConfig: {
          container: {
            alignItems: 'center',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            height: this.size,
            width: this.size,
          },
          image: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
          },
        },
      };
    },
    created: function () {
      this.defaultSrc = require(`@img/${this.imageFile}`);

      Object.assign(
        this.styleConfig.image,
        {
          filter: {
            '': 'none',
            hover: 'opacity(0.5)',
            active: 'opacity(0.5)',
            disabled: 'opacity(1.0)',
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      href: function () {
        const tenantUserId = this.tenantUser?.id?.toString();
        if (tenantUserId == null) {
          return null;
        }
        return `${path.join(process.env.BASE_URL, 'users', tenantUserId)}`;
      },
      src: function () {
        const image = this.tenantUser?.user?.image;
        return image === null || image === undefined || image === ''
          ? this.defaultSrc
          : image;
      },
    },
  };
</script>
